import { SettingsState } from './types';

export const initialState: SettingsState = {
  isGameSearchActive: false,
  triggerBonusModal: false
};
